import { render, staticRenderFns } from "./LembreteExpiracaoSenha.vue?vue&type=template&id=729671be&scoped=true"
import script from "./LembreteExpiracaoSenha.vue?vue&type=script&lang=js"
export * from "./LembreteExpiracaoSenha.vue?vue&type=script&lang=js"
import style0 from "./LembreteExpiracaoSenha.vue?vue&type=style&index=0&id=729671be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729671be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729671be')) {
      api.createRecord('729671be', component.options)
    } else {
      api.reload('729671be', component.options)
    }
    module.hot.accept("./LembreteExpiracaoSenha.vue?vue&type=template&id=729671be&scoped=true", function () {
      api.rerender('729671be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LembreteExpiracaoSenha.vue"
export default component.exports